import {
  ProfileScreenRoute,
  isRouteActive,
} from "@components/Account/Layout/utils";
import Indicator from "@components/Indicator";
import LBox from "@components/LBox";
import LLink from "@components/LLink";
import LText from "@components/LText";
import useIsArtistManager from "@hooks/useIsArtistManager";
import { fonts, theme } from "@theme";
import { useNavigationStore } from "@utils/navigation/useNavigationStore";
import { Href } from "expo-router";
import React from "react";
import { Dimensions } from "react-native";

const WINDOW_WIDTH = Dimensions.get("window").width;
const DIVIDER_STYLE = {
  height: 1,
  marginLeft: -theme.spacing.s4,
  width: WINDOW_WIDTH,
};

const RouteLink = ({
  route,
  title,
  isArtistRoute,
  subRoutes,
  tipName: _tipName,
}: {
  route: Href;
  title: string;
  isArtistRoute?: boolean;
  subRoutes?: Href[];
  tipName?: string;
}) => {
  const pathName = useNavigationStore((state) => state.currentPath);
  const isArtistManager = useIsArtistManager();

  const active = isRouteActive(pathName, route, subRoutes);

  if (isArtistRoute && !isArtistManager) {
    return null;
  }

  return (
    <>
      <LLink
        disabled={active}
        href={route}
        replace
        sentryEventName={`account_header_link_${title}`}
        onPress={() => {
          // if (tipName) {
          // }
        }}
      >
        <LBox gap="s1_5">
          <LText
            color={active ? "textPrimary" : "subText"}
            fontSize={16}
            fontFamily={fonts.semiBold}
            lineHeight={28}
          >
            {title}
          </LText>
          <Indicator active={!!active} />
        </LBox>
      </LLink>
    </>
  );
};

const Header = ({ routes }: { routes: ProfileScreenRoute[] }) => {
  return (
    <LBox>
      <LBox alignItems="center" flexDirection="row" gap="m1">
        {routes.map(({ route, title, isArtistRoute, subRoutes, tipName }) => (
          <RouteLink
            key={route.toString()}
            route={route}
            title={title}
            isArtistRoute={isArtistRoute}
            subRoutes={subRoutes?.map((sr) => sr.route)}
            tipName={tipName}
          />
        ))}
      </LBox>
      <LBox bg="faintWhite" style={DIVIDER_STYLE} />
    </LBox>
  );
};

export default Header;
